import React from "react";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const services = ["Workforce Supply", "Project Management", "Industrial Logistics", "Mechanical Installation", "Electrical Engineering", "Structural Steel", "Site Management", "Compliance & Safety", "Transport Solutions", "Payroll Services", "Technical Staffing"];
  const navLinks = [{
    label: "Home",
    to: "/VSGroupPage"
  }, {
    label: "About Vantage Support Group",
    to: "/VSGroupPage#about"
  }, {
    label: "Our Services",
    to: "/VSGroupPage#services"
  }, {
    label: "Market Segments",
    to: "/VSGroupPage#market"
  }, {
    label: "Careers",
    to: "/VSGroupPage#careers"
  }, {
    label: "Contact",
    to: "/VSGroupPage#contact"
  }];
  return;
}